var getConfigFromDom;

module.exports = getConfigFromDom = function(id) {
  var elt, error, text;
  if (id == null) {
    id = 'domConfig';
  }
  elt = document.getElementById(id);
  if (!elt) {
    return {};
  }
  text = elt.textContent || elt.innerText;
  try {
    return JSON.parse(text);
  } catch (error1) {
    error = error1;
    error.message += '\n     Attempted to parse: ' + text;
    throw error;
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvY29yZS9mcm9udGVuZC9ncm91cG9uX21vZHVsZXMvZ2V0Q29uZmlnRnJvbURvbS5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvVXNlcnMvYXJpY2h0ZXIvcmVwb3NpdG9yaWVzL3Nscy9jb3JlL2Zyb250ZW5kL2dyb3Vwb25fbW9kdWxlcy9nZXRDb25maWdGcm9tRG9tLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxJQUFBOztBQUFBLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLGdCQUFBLEdBQW1CLFNBQUMsRUFBRDtBQUNsQyxNQUFBOztJQURtQyxLQUFLOztFQUN4QyxHQUFBLEdBQU0sUUFBUSxDQUFDLGNBQVQsQ0FBd0IsRUFBeEI7RUFDTixJQUFhLENBQUMsR0FBZDtBQUFBLFdBQU8sR0FBUDs7RUFDQSxJQUFBLEdBQU8sR0FBRyxDQUFDLFdBQUosSUFBbUIsR0FBRyxDQUFDO0FBSTlCO1dBQ0UsSUFBSSxDQUFDLEtBQUwsQ0FBVyxJQUFYLEVBREY7R0FBQSxjQUFBO0lBRU07SUFDSixLQUFLLENBQUMsT0FBTixJQUFpQiw2QkFBQSxHQUFnQztBQUNqRCxVQUFNLE1BSlI7O0FBUGtDIn0=
